<!-- svelte-ignore a11y-label-has-associated-control -->
{#if company}

  {#if showToast}
    <div class="notification is-success">
      <button class="delete" on:click={() => (showToast = false)} />
      Contact and business updated
    </div>
  {/if}

  <hr />
  <h2 class="is-size-4">Contact</h2>

  {#if userId}

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Email</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" disabled bind:value={userId} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">First name</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" bind:value={user.firstName} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Last name</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" bind:value={user.lastName} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Phone</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" bind:value={user.phone} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <a href="{$url('/admin/user/' + userId)}">View details</a>
        </div>
      </div>
    </div>
  </div>

  {:else}

  <div>No user account associated with this business.</div>

  {/if}

  <hr />
  <h2 class="is-size-4">Business</h2>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Name</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" bind:value={company.name} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Website</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input class="input" bind:value={company.website} />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">First line</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder=""
            bind:value={company.address.addressline1}
          />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Second line</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder=""
            bind:value={company.address.addressline2}
          />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Town</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder=""
            bind:value={company.address.posttown}
          />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Postcode</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <input
            class="input"
            type="text"
            placeholder=""
            bind:value={company.address.postcode}
          />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Message (HTML)</label>
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <textarea
            class="textarea"
            placeholder=""
            rows="5"
            bind:value={company.message}
          />
        </div>
      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">Subscription expiry date</label>
    </div>
    <div class="field-body">
      <div class="field is-grouped">

        {#if company.subscriptions?.current?.expiryDate} 
        <div class="control">
          <input class="input" type="date" bind:value={company.subscriptions.current.expiryDate} />
        </div>
        <div class="control">
          <button class="button is-secondary" on:click={deleteSubscription}>Delete subscription</button>
        </div>
        {:else}
        <div class="control">
          <button class="button is-secondary" disabled={!isAdmin} on:click={addSubscription}>Add subscription</button>
        </div>
        {/if}

      </div>
    </div>
  </div>

  <div class="field is-horizontal">
    <div class="field-label">
      <!-- Left empty for spacing -->
    </div>
    <div class="field-body">
      <div class="field">
        <div class="control">
          <button
            class="button is-primary"
            class:is-loading={isLoading}
            disabled={!isAdmin}
            on:click={() => apply()}>Save</button
          >
        </div>
      </div>
    </div>
  </div>

  {#if errorMessage}
    <div class="block">
      <div class="notification is-danger is-light">
        {errorMessage}
      </div>
    </div>
  {/if}
{/if}

<script lang="ts">
  export let id :string;

  import _ from "lodash";
  import { appState } from "../../../../lib/appState";
  import { uiState } from '../../../../lib/uiState';
  import { params, goto, url } from "@sveltech/routify";
  import dayjs from "dayjs";
  import { logging } from '../../../../lib/logging';

  id = $params["id"];

  let company :Company_v1;
  let user : User_v1;
  let userId :string;

  let showToast = false;
  let errorMessage :string;
  let isLoading = false;

  let firebase = window.firebase;

  $: isAdmin = $appState.user?.isFullAdmin || ($appState.user?.delegatedAdminTag !== undefined && company?.tags?.includes($appState.user.delegatedAdminTag));

  get();

  async function get() {
    firebase
      .firestore()
      .collection("companies_v1")
      .doc(id)
      .get()
      .then((doc) => {
        company = doc.data() as Company_v1;
        company.address = company.address || null;
      });

    firebase
      .firestore()
      .collection("users_v1")
      .where("company", "==", id)
      .get()
      .then((snap) => {
        const doc = _.find(snap.docs, (doc) => !doc.data().isAdmin);
        if (doc) {
          userId = doc.id;
          user = doc.data() as User_v1;
        }
      });
  }

  function addSubscription() {

    const companyUpdate = {
      subscriptions: {
        current: {
          expiryDate: dayjs().add(1, 'month').toISOString().substring(0, 10)
        }
      }
    };
    
    company = _.merge(company, companyUpdate);
  }

  function deleteSubscription() {
    company.subscriptions.current = undefined;
  }

  async function apply() {
    let firebase = window.firebase;

    try {
      isLoading = true;
      await firebase
        .firestore()
        .collection("users_v1")
        .doc(userId)
        .update(user);

      let result = await firebase.functions().httpsCallable('api-account-updatecompany')({
        id,
        company,
      } as UpdateCompanyParams);

      company = result.data.company;

      showToast = true;
    } catch (err:any) {
      errorMessage = err.toString();
      logging.report(err.toString());
    }
    isLoading = false;
  }


</script>
